<template>
  <a-button
    :size="size"
    type="outline"
    class="hhxc-square-button"
    :class="{ mlr10: showMargin }"
    :loading="refLoading"
    :style="{ height, width, fontSize }"
    @click="handleRefresh"
    :hover="{ 'border-color': 'red' }"
  >
    <template #icon>
      <icon-refresh />
    </template>
  </a-button>
</template>

<script>
  import { inject, ref, watch } from 'vue'
  export default {
    name: 'refreshPage',
    props: {
      height: {
        default: '',
        type: String,
      },
      width: {
        default: '',
        type: String,
      },
      fontSize: {
        default: '',
        type: String,
      },
      size: {
        default: 'small',
        type: String,
      },
      loading: {
        default: false,
        type: Boolean,
      },
      reload: {
        default: false,
        type: Boolean,
      },
      showMargin: {
        default: true,
        type: Boolean,
      },
    },

    setup(props, context) {
      const reload = inject('reload')
      const refLoading = ref(false)
      const handleRefresh = async () => {
        if (props.reload) return reload?.()
        context.emit('refresh')
      }
      watch(
        () => props.loading,
        () => {
          refLoading.value = props.loading
        }
      )
      return {
        refLoading,
        handleRefresh,
      }
    },
  }
</script>
